"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.dashboard.heading': 'Centrum planowania treści',
    'socialMediaPlan.dashboard.desc': 'Twórz treść, wybierz kanały, planuj publikację i śledź wyniki.',
};
